import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import Cookies from "js-cookie";

const useBypassDeeperdive = () => {
  const [isBypassEnabled, setIsBypassEnabled] = useState<boolean | null>(null);
  const [searchParams] = useSearchParams();
  const isBypassDemo = searchParams.get("dd_demo") === "true";

  useEffect(() => {
    if (typeof window === "undefined") return;
    const cookie = Cookies.get("bypass_deeperdive");

    if (typeof cookie !== "undefined" && cookie === "1") {
      setIsBypassEnabled(true);

      return;
    }

    if (isBypassDemo) {
      Cookies.set("bypass_deeperdive", "1");
      setIsBypassEnabled(true);

      return;
    }

    setIsBypassEnabled(false);
  }, [isBypassDemo]);

  return {
    isBypassEnabledReady: isBypassEnabled !== null,
    isBypassEnabled: isBypassEnabled,
  };
};

export default useBypassDeeperdive;
